import React, { useState } from 'react';

const Hero: React.FC = () => {
  const [showVideo, setShowVideo] = useState(false);

  const handleVideoClick = () => {
    setShowVideo(true);
  };

  const handleCloseVideo = () => {
    setShowVideo(false);
  };

  return (
    <section className="min-h-screen flex items-center justify-center text-center pt-24 sm:pt-32 pb-16 sm:pb-20 px-4 sm:px-6 bg-gradient-to-br from-white via-blue-50 to-blue-100 w-full">
      <div className="max-w-4xl w-full">
        <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light leading-tight tracking-tight text-gray-900 mb-6 sm:mb-8">
          Relatable Remembers.
        </h1>
        <p className="font-sans text-lg sm:text-xl font-normal text-gray-600 mb-6 sm:mb-8 max-w-2xl mx-auto leading-relaxed">
          We help you (and your team) stay in touch with the people that matter for your business, career, and life.
        </p>
        <p className="font-sans text-base sm:text-lg font-normal italic mb-8 sm:mb-12 max-w-2xl mx-auto text-gray-500">
          Like that friend who won't let you forget to call your mom. But for your entire network. We're basically your relationship's personal assistant, but without the awkward small talk.
        </p>
        
        <div className="mt-8 sm:mt-12">
          <div 
            className="w-full max-w-2xl h-48 sm:h-64 md:h-80 bg-white border border-gray-200 rounded-xl relative mx-auto overflow-hidden shadow-lg cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl"
            onClick={handleVideoClick}
          >
            {/* Video GIF */}
            <img 
              src="/videogif.gif" 
              alt="Relatable Demo Video" 
              className="w-full h-full object-cover"
            />
            
            {/* Overlay with play button */}
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/20 text-gray-900">
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mb-4 transition-all duration-200 hover:scale-110 text-white shadow-lg"
                style={{
                  backgroundColor: 'var(--primary-color)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--primary-hover)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--primary-color)';
                }}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M8 5v14l11-7z" fill="currentColor"/>
                </svg>
              </div>
              <p className="font-sans text-sm font-medium text-white m-0">
                Watch how it works
              </p>
            </div>
          </div>
        </div>
      </div>

                        {/* Video Modal */}
                  {showVideo && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" onClick={handleCloseVideo}>
                      <div className="relative w-full max-w-4xl animate__animated animate__jackInTheBox" onClick={(e) => e.stopPropagation()}>
                        <button 
                          onClick={handleCloseVideo}
                          className="absolute -top-10 sm:-top-12 right-0 text-white text-xl sm:text-2xl hover:text-gray-300 transition-colors duration-200 z-10"
                        >
                          ✕
                        </button>
                        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                          <iframe
                            src="https://www.youtube.com/embed/i_AxUiW63Xs?autoplay=1&modestbranding=1&controls=1&rel=0&showinfo=0&iv_load_policy=3&cc_load_policy=0&fs=0"
                            title="Relatable Demo Video"
                            className="absolute top-0 left-0 w-full h-full rounded-lg"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        </div>
                      </div>
                    </div>
                  )}
    </section>
  );
};

export default Hero; 